import type { Step } from "react-joyride";

export const auditPlanListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການຜະແນການກວດສອບ! ຫນ້ານີ້ຈະສະແດງລາຍການຜະແນການກວດສອບທັງໝົດ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="plan-toolbar"]',
    content:
      "ນີ້ແມ່ນແຖບເຄື່ອງມື. ທ່ານສາມາດກົດປຸ່ມ 'ສ້າງຜະແນການກວດສອບໃໝ່' ເພື່ອສ້າງຜະແນການກວດສອບໃໝ່.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="plan-filter"]',
    content:
      "ນີ້ແມ່ນຕົວກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາ, ກອງຕາມສະຖານະ, ພະແນກ, ປະເພດການກວດສອບ, ຫຼືຄວາມຖີ່ເພື່ອຊອກຫາຜະແນການກວດສອບທີ່ຕ້ອງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="plan-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງຜະແນການກວດສອບ. ທ່ານຈະເຫັນລາຍການຜະແນການກວດສອບທັງໝົດ. ກົດທີ່ແຖວເພື່ອເບິ່ງລາຍລະອຽດ, ຫຼືໃຊ້ປຸ່ມການກະທຳເພື່ອແກ້ໄຂຫຼືລຶບ.",
    placement: "top",
  },
];
